module.exports = __webpack_public_path__ + "img/slika2.b9b8e3db.jpg";